import React from 'react'
import {
  SimpleForm,
  required,
  minLength,
  FormDataConsumer,
  ArrayField,
  Datagrid,
  TextField,
  Link,
  useCreatePath,
} from 'react-admin'
import { facetDescriptionOptions } from 'services/cfg/form'
import { APILinkedProduct, CustomFormProps } from 'types/common'
import FACET_FORM_MAP, { FacetFormExtension } from './FacetsCategoryFields'
import 'react-quill/dist/quill.snow.css'
import { FacetCategory } from 'services/api/entities/catalog/facets'
import { PRODUCT_ENTITY_SERVICE_MAP } from 'services/utils/name-maps'
import LocalizedTextField from 'ui-shared/LocalizedFields/LocalizedTextField'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import DescriptionInput from 'ui-shared/WrappedInputs/DescriptionInput'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const LinkField: React.FC = () => {
  const record = useKRecordContext<APILinkedProduct>()

  const product = record ? PRODUCT_ENTITY_SERVICE_MAP[record.type] : undefined
  const createPath = useCreatePath()

  const link = createPath({
    resource: `/${product}`,
    id: record?.id,
    type: 'edit',
  })

  return <Link to={link}>Go To Product Page</Link>
}

type Props = CustomFormProps & {
  disable?: boolean
}

const FacetForm: React.FC<Props> = ({ disable = false }) => (
  <SimpleForm>
    <DescriptionInput />
    <KSelectInput
      disabled={disable}
      source="category"
      defaultValue="tag"
      label="form.fields.category"
      validate={[required(), minLength(1)]}
      choices={facetDescriptionOptions}
      fullWidth
    />
    <FormDataConsumer>
      {({ formData: { category } }) => {
        const FacetCategoryFields: FacetFormExtension =
          FACET_FORM_MAP[category as FacetCategory]
        return category ? <FacetCategoryFields disable={disable} /> : null
      }}
    </FormDataConsumer>

    <ArrayField source="products">
      <Datagrid style={{ width: '600px' }}>
        <LocalizedTextField sortable={false} source="name" />
        <TextField sortable={false} source="type" />
        <LinkField />
      </Datagrid>
    </ArrayField>
  </SimpleForm>
)

export default FacetForm
